import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  makeStyles,
  Divider,
  Grid,
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useMobileScreen } from '~/helpers/useMediaQuery'
import { Creators as CircularsActions } from '~/store/ducks/circulars'
import styles from './styles'

const useStyles = makeStyles(styles)

const circularSelector = ({ circulars }) => circulars.circularData

const ViewCircularDialog = ({ open, onClose, id }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const circular = useSelector(circularSelector)
  const isMobileScreen = useMobileScreen()
  const isEdit = !!id

  useEffect(() => {
    if (isEdit && open) {
      dispatch(CircularsActions.getCircularRequest(id))
    }

    return () => {
      dispatch(CircularsActions.resetCircularData())
    }
  }, [isEdit, id, open])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      fullScreen={isMobileScreen}
      maxWidth="md"
      classes={{ paper: classes.paper }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">
          {`Visualizar circular #${id}`}
        </Typography>
      </DialogTitle>
      <Divider className={classes.divider} />

      <DialogContent className={classes.dialogContent}>
        {circular && (
          <iframe
            title="circular"
            src={circular?.url_pdf_file}
            width="100%"
            height="600px"
            style={{ border: 'none' }}
          />
        )}
      </DialogContent>
      <Divider className={classes.divider} />
      <DialogActions className={classes.buttonForm}>
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item>
            <Button
              fullWidth={isMobileScreen}
              onClick={onClose}
              variant="contained"
            >
              CANCELAR
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}

ViewCircularDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  id: PropTypes.number,
}

ViewCircularDialog.defaultProps = {
  id: null,
}

export default ViewCircularDialog
